import React, { FC } from 'react'
import styles from './Preferences.module.scss'
import { MODAL_NAME } from 'components/Preferences/Modal/Preferences'
import ArrowRightIcon from 'svg/thicker-arrow.svg'
import CountryFlagSvg from 'components/CountryFlag/CountryFlagSvg'
import useModal from 'hooks/useModal'
import { useSelector } from 'react-redux'
import {
  getUserPreferences,
  getUserPreferencesCountryCode,
  getUserPreferencesCountryName,
  getUserPreferencesCurrency,
  getUserPreferencesMeasurementUnit,
} from 'selectors/user/cookie'
import { getLocaleIsReady } from 'selectors/shared/locale'
import classNames from 'classnames'
type PreferencesProps = { isStudio?: boolean }
const PreferencesFooter: FC<PreferencesProps> = ({ isStudio }) => {
  const localeIsReady = useSelector(getLocaleIsReady)
  const userPreferences = useSelector(getUserPreferences)
  const userPreferencesCountryCode = useSelector(getUserPreferencesCountryCode)
  const userPreferencesCountryName = useSelector(getUserPreferencesCountryName)
  const userPreferencesCurrency = useSelector(getUserPreferencesCurrency)
  const userPreferencesMeasurementUnit = useSelector(getUserPreferencesMeasurementUnit)
  const { showModal } = useModal()

  // Hide currency selector for specific pages
  if (!localeIsReady || !userPreferences) {
    return null
  }

  return (
    <div
      title='View Store Preferences Footer'
      className={styles.userPreferencesBox}
      onClick={() => showModal(MODAL_NAME)}
      data-type='country-flag-icon-footer'
    >
      <CountryFlagSvg
        customClassName={styles.userPreferencesCountryFlag}
        country={userPreferencesCountryCode?.toLowerCase()}
      />
      <div
        className={classNames(styles.userPreferencesText, {
          [styles.userPreferencesTextStudio]: isStudio,
        })}
      >
        <span>{userPreferencesCountryName}</span>
        {'/'}
        <span>{userPreferencesCurrency}</span>
        {'/'}
        <span className={styles.userPreferencesUnit}>{userPreferencesMeasurementUnit}</span>
        <ArrowRightIcon />
      </div>
    </div>
  )
}

export default PreferencesFooter
